import React, { useContext, useEffect } from "react";
import PublicLayout from "../layout/PublicLayout";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard/Dashboard";
import LoginPage from "../components/Auth/Login/LoginPage";
import RegisterPage from "../components/Auth/Register/RegisterPage";
import { AuthContext } from "../contexts/AuthContext";
import AllCourses from "../pages/AllCourses/AllCourses";
import MyCourses from "../pages/MyCourses/MyCourses";
import NotFound from "../components/NotFound/NotFound";
import Notifications from "../pages/Notifications/Notifications";
import TeacherCourses from "../pages/MyCourses/TeacherCourses";
import { SpinnerInfinity } from "spinners-react";
import ManageUsers from "../pages/ManageUsers/ManageUsers";
import SoonFuture from "../pages/SoonFuture/SoonFuture";

const PublicRoutes = () => {
  const { accessToken, teacher, admin, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      if (!accessToken) {
        if (
          location.pathname !== "/login" &&
          location.pathname !== "/register"
        ) {
          navigate("/login");
        }
      } else {
        if (
          location.pathname === "/login" ||
          location.pathname === "/register"
        ) {
          navigate("/");
        }
      }
    }
  }, [accessToken, navigate, location.pathname, loading]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <SpinnerInfinity
          size={75}
          thickness={64}
          speed={55}
          color="rgba(57, 152, 172, 1)"
          secondaryColor="rgba(0, 0, 0, 0.44)"
          className="mx-2"
        />
        Loading...
      </div>
    );
  }

  return (
    <>
      {!accessToken && (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Routes>
      )}
      {accessToken && (
        <PublicLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/courses/register/" element={<AllCourses />} />
            <Route
              path="/courses/"
              element={teacher ? <TeacherCourses /> : <MyCourses />}
            />
            <Route path="/assignments/" element={<SoonFuture />} />
            <Route path="/exams/register" element={<SoonFuture />} />
            <Route path="/exams" element={<SoonFuture />} />
            <Route path="/class/schedule" element={<SoonFuture />} />
            <Route path="/exam/results" element={<SoonFuture />} />
            <Route path="/announcement" element={<SoonFuture />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="*" element={<NotFound />} />

            {accessToken && admin && (
              <>
                <Route path="/manage/users" element={<ManageUsers />} />
                <Route path="/courses/manage" element={<SoonFuture />} />
                <Route path="/exams/manage" element={<SoonFuture />} />
              </>
            )}
          </Routes>
        </PublicLayout>
      )}
    </>
  );
};

export default PublicRoutes;
